jQuery(document).ready(function(){
    jQuery(window).scroll(function(){
        if(jQuery(window).width() <= 820){
                jQuery('.product-block .halo-block').each(function(){
                    if(jQuery(this).hasClass('ajax-loaded') && !jQuery(this).find('.products-grid').hasClass('slick-slider')){
                        console.log('test');
                        setTimeout(() => {
                            jQuery(this).find('.products-grid.column-4').slick({
                                infinite: true,
                                dots: true,
                                speed: 500,
                                fade: true,
                                cssEase: 'linear',
                                autoplay: true,
                                autoplaySpeed: 5000,
                            });
                        }, 2000);
                        
                    }
                });
            
            
        }
    });
    
});